import { api } from "@/services/api";
import { AddEventViewModel, EventModel } from "../types/event";

const eventApi = api.injectEndpoints({
  endpoints: (build) => ({
    addEventView: build.query<AddEventViewModel, void>({
      query: () => {
        return {
          url: "api/Event/AddEventView",
          method: "get",
        };
      },
    }),
    addEditEvent: build.mutation<EventModel[], any>({
      query: (payload) => {
        return {
          url: "api/Event/AddEditEvent",
          method: "post",
          data: payload,
          hideLoading: true,
        };
      },
    }),
    getEvents: build.mutation<EventModel[], any>({
      query: (payload) => {
        return {
          url: "api/Event/GetEvents",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddEventViewQuery,
  useAddEditEventMutation,
  useGetEventsMutation,
} = eventApi;

export default eventApi;
